export {default} from "@features/swing-trading/scanner-screen";
